<div class="dialog-container">
  <div class="dialog-header">
    <button class="close-btn" (click)="closeDialog()">×</button>
  </div>

  <!-- Loading Spinner -->
  <div *ngIf="isLoading" style="text-align: center; padding: 50px;">
    <p>Loading...</p>
  </div>

  <!-- Report Content -->
  <div *ngIf="!isLoading" class="report-wrapper" id="print-area">
    <table class="ledger-table" id="business-report-table">
      <thead>
        <tr class="main-header">
          <th colspan="3">नियमित / विशेषांक जाहिरात तपशील ({{ financialYearLabel }})</th>
          <th colspan="2">दिनांक : {{ todayDate }}</th>
          <th colspan="4" class="empty-cell"></th>
          <th rowspan="2" class="vertical-header">महिन्याप्रमाणे झालेला <br>व्यवसाय</th>
        </tr>
        <tr class="sub-header">
          <th style="width: 40px;">अ.क्र.</th>
          <th>महिना</th>
          <th>देयक दिनांक</th>
          <th>मागील वर्ष</th>
          <th>एकूण रुपये</th>
          <th>वर्तन रु.</th>
          <th>निव्वळ रु.</th>
          <th>जमा रु.</th>
          <th>येणे बाकी</th>
        </tr>
      </thead>

      <tbody>
        <!-- Dynamic Categories Loop -->
        <ng-container *ngFor="let category of allCategories">

          <!-- Category Header -->
          <tr>
            <td colspan="10" class="section-divider" style="background-color: cadetblue;">
              <u style="font-weight: bold;font-size: 16px;">{{ category.category_name }}</u>
            </td>
          </tr>

          <!-- Category Data Rows -->
          <tr *ngFor="let row of category.monthly_data; let i = index">
            <td>{{ i + 1 }}</td>
            <td class="text-left" style="font-size: 14px;">{{ row.month }}</td>
            <td>{{ row.bill_date || '-' }}</td>
            <td style="text-align: right;font-size: 14px;">{{ row.prev_year || 0 }}</td>
            <td style="text-align: right;font-size: 14px;">{{ row.total_amt || 0 }}</td>
            <td style="text-align: right;font-size: 14px;">{{ row.varta_rs || 0 }}</td>
            <td style="text-align: right;font-size: 14px;">{{ row.net_rs || 0 }}</td>
            <td style="text-align: right;font-size: 14px;">{{ row.jama_rs || 0 }}</td>
            <td style="text-align: right;font-size: 14px;">{{ row.balance || 0 }}</td>
            <td class="bg-light" style="text-align: right;font-size: 14px;">{{ row.monthly_total
              || 0 }}</td>
          </tr>

          <!-- Category Total Row -->
          <tr class="category-total-row" style="background-color: #ffd700;font-size: 18px;">
            <td colspan="3"><b>{{ category.category_name }} - एकूण</b></td>
            <td style="text-align: right;font-size: 14px;font-weight: bold;">{{
              calculateCategoryTotal(category.monthly_data, 'prev_year') }}</td>
            <td style="text-align: right;font-size: 14px;font-weight: bold;">{{
              calculateCategoryTotal(category.monthly_data, 'total_amt') }}</td>
            <td style="text-align: right;font-size: 14px;font-weight: bold;">{{
              calculateCategoryTotal(category.monthly_data, 'varta_rs') }}</td>
            <td style="text-align: right;font-size: 14px;font-weight: bold;">{{
              calculateCategoryTotal(category.monthly_data, 'net_rs') }}</td>
            <td style="text-align: right;font-size: 14px;font-weight: bold;">{{
              calculateCategoryTotal(category.monthly_data, 'jama_rs') }}</td>
            <td style="text-align: right;font-size: 14px;font-weight: bold;">{{
              calculateCategoryTotal(category.monthly_data, 'balance') }}</td>
            <td style="text-align: right;font-size: 14px;font-weight: bold;">{{
              calculateCategoryTotal(category.monthly_data, 'net_rs') }}</td>
          </tr>

        </ng-container>
      </tbody>

      <tfoot>
        <tr class="grand-total-row" style="background-color: aqua;">
          <td colspan="3"><b>एकूण</b></td>
          <td style="text-align: right;font-size: 16px;">{{ calculateGrandTotal('prev_year') }}</td>
          <td style="text-align: right;font-size: 16px;">{{ calculateGrandTotal('total_amt') }}</td>
          <td style="text-align: right;font-size: 16px;">{{ calculateGrandTotal('varta_rs') }}</td>
          <td style="text-align: right;font-size: 16px;">{{ calculateGrandTotal('net_rs') }}</td>
          <td style="text-align: right;font-size: 16px;">{{ calculateGrandTotal('jama_rs') }}</td>
          <td style="text-align: right;font-size: 16px;">{{ calculateGrandTotal('balance') }}</td>
          <td style="text-align: right;font-size: 16px;">{{ calculateGrandTotal('net_rs') }}</td>
        </tr>

        <!-- ✅ Dynamic end date from selected financial year -->
        <tr style="background-color: #e0e0e0;">
          <td colspan="7" style="text-align: center; font-weight: bold; font-size: 15px; padding: 6px;">
            शिलक करार ३१/०३/{{ footerCurrYear }} अखेर एकूण
          </td>
          <td colspan="3" style="text-align: right; font-weight: bold; font-size: 15px; padding: 6px;">
            {{ calculateGrandTotal('balance') }}
          </td>
        </tr>

        <!-- ✅ Dynamic Feb labels -->
        <tr style="background-color: #f5f5f5;">
          <td colspan="3" style="text-align: left; font-size: 14px; padding: 5px; font-weight: bold;">
            फेब्रुवारी - {{ footerPrevYear }} अखेरची स्तिती
          </td>
          <td colspan="2" style="text-align: right; font-size: 14px; padding: 5px; border-right: 2px solid #ccc;">
            {{ februaryValue2025 || 0 }}
          </td>
          <td colspan="3" style="text-align: left; font-size: 14px; padding: 5px; font-weight: bold;">
            फेब्रुवारी - {{ footerCurrYear }} अखेरची स्तिती
          </td>
          <td colspan="2" style="text-align: right; font-size: 14px; padding: 5px;">
            {{ februaryValue2026 || 0 }}
          </td>
        </tr>

        <!-- ✅ Dynamic March labels -->
        <tr style="background-color: #efefef;">
          <td colspan="3" style="text-align: left; font-size: 14px; padding: 5px; font-weight: bold;">
            मार्च - {{ footerPrevYear }} अखेरची स्तिती
          </td>
          <td colspan="2" style="text-align: right; font-size: 14px; padding: 5px; border-right: 2px solid #ccc;">
            {{ marchValue2025 || 0 }}
          </td>
          <td colspan="3" style="text-align: left; font-size: 14px; padding: 5px; font-weight: bold;">
            मार्च - {{ footerCurrYear }} अखेरची स्तिती
          </td>
          <td colspan="2" style="text-align: right; font-size: 14px; padding: 5px;">
            {{ marchValue2026 || 0 }}
          </td>
        </tr>
      </tfoot>
    </table>
  </div>

  <div class="dialog-actions no-print">
    <button mat-raised-button color="primary" (click)="printPageA4Portrait()" [disabled]="isLoading">Print</button>
    <button mat-raised-button color="accent" (click)="exportToExcel()" [disabled]="isLoading">Export to Excel</button>
    <button mat-button (click)="closeDialog()">बंद करा</button>
  </div>
</div>